<template>
  <main ref="main" role="main" class="about">
    <!-- <div class="content-container"  v-html="">
    </div> -->
    <!-- <h2>Credits</h2><p>Design & Code by <a href=https://alfatih.world target=_blank>Alfatih</a><br>Typface is Riforma by <a href=https://lineto.com target=_blank>Lineto</a></p> -->
    <section class="aboutColumn">
		<div class="bigColOne">
			<div>
				<h1>Contact</h1>
				<address class="vcard">
					<p >
						<span class="fn org">{{infos.name}}</span><br>
						<a class="adr" :href="'https://www.google.com/maps/search/?api=1&query='+infos.name+'+'+infos.address+'+'+infos.npa+'+'+infos.locality+'+'+infos.country" target="_blank">
						<span class="street-address">{{infos.address}}</span><br>
						<span class="postal-code">{{infos.npa}} </span> <span class="locality">{{infos.locality}}</span><br>
						<span class="country-name">{{infos.country}}</span><br>
						</a>
					</p>
					<p>
					<a class="email" :href="'mailto:'+infos.email">{{infos.email}}</a><br>
					<a :href="'tel:'+infos.phone.replace(/\s/g, '')">{{infos.phone}}</a>
					</p>
				</address>
				<h2>Open hours</h2>
				<p>{{infos.opendays}}<br>
				{{infos.openhours}}<br>
				</p>
				<p>
					Or anytime by phone appointment<br>
				</p>
			</div>
			<div>
    			<vue-markdown :class="'aboutTextarea'" :source="pageAbout.aboutsecond" :anchorAttributes="{target: '_blank'}"></vue-markdown>

			</div>
		</div>
		<div class="bigColTwo">
			<div>
				<vue-markdown :class="'aboutTextarea'" :source="pageAbout.aboutthird" :anchorAttributes="{target: '_blank'}"></vue-markdown>
			</div>
			<div>
				<h2>Newsletter</h2>

				<p>
					<form action="https://wallriss.us19.list-manage.com/subscribe/post?u=2b4fdd4dce18b9460d18b7bec&amp;id=7917b4a470" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
					<!-- <label for="mce-EMAIL">Subscribe to our mailing list</label> -->
					
					<input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
						<!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
						<div style="position: fixed; left: -5000px; top: -5000px" aria-hidden="true"><input type="text" name="b_2b4fdd4dce18b9460d18b7bec_7917b4a470" tabindex="-1" value=""></div>
						<input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">

					</form>
				</p>

				<h2>Keep in touch</h2>
				<p>
					<!-- <a :href="'https://wallriss.us19.list-manage.com/subscribe/post?u=2b4fdd4dce18b9460d18b7bec&amp%3Bid=7917b4a470&fbclid=IwAR3HV4Ltl72th2WdUAueEe8UG3jlPz_O54p8RNqVWit0ZivG-3sr86-Ix20'" target="_blank">Newsletter</a><br> -->
					<a :href="infos.instagram" target="_blank">Instagram</a><br>
					<a :href="infos.facebook" target="_blank">Facebook</a>
				</p>

				<vue-markdown :class="'aboutTextarea'" :source="pageAbout.aboutfourth" :anchorAttributes="{target: '_blank'}"></vue-markdown>

			</div>
		</div>



    </section>

  </main>
</template>

<script>

import VueMarkdown from 'vue-markdown'

export default {
  name: 'about',
  components: {
    VueMarkdown
  },
  metaInfo () {
    return {
      title: this.title
    }
  },
  computed: {
    pageAbout () {
      return this.$store.getters.getPageByUID('about')
    },
    infos () {
      return this.$store.getters.getPageByUID('infos')
    }
  },
  data () {
    return {
      title: this.$store.getters.getPageByUID('about').title
    }
	},
  mounted () {
    this.$refs.main.focus()
  }
}
</script>

<style lang="scss">
  	@import './../assets/styles/general/mixins';
	@import './../assets/styles/config';
  .about {
  	// display: flex;
  	// flex-wrap: wrap;
  	// flex-direction: row-reverse;
  	height: 100%;
  	width: 100%;
  	overflow-y: auto;
  	overflow-x: hidden;
  	-webkit-overflow-scrolling: touch;
  	// position: absolute;
  	// top: 0;
  	// left: 0;

  	::-moz-selection {
  		/* Code for Firefox */
  		color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
  		// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
  		text-shadow: 0px 0px 0.1em black;
  	}

  	::selection {
  		color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
  		// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
  		text-shadow: 0px 0px 0.1em black;
  	}
  	.aboutColumn {
		width: 100%;
		padding: 1rem;
		@include fluid-type(400px, 1300px, 11.666666px, 12px);
		display: flex;
		@media screen and (max-width: $mq-tablet) {
			flex-wrap: wrap;
			@include fluid-type(400px, 1300px, 5.888888888px, 12px);
		}
  	}
	  .bigColOne, .bigColTwo {
		  min-width: 50%;
		  display: flex;
		  flex-wrap: wrap;
		  align-content: flex-start;
			@media screen and (max-width: $mq-tablet) {
				width: 100%
			}
		& > div {
			&:first-child {
				margin-bottom: 1.8em;
			}

			width: 50%;
			min-width: 340px;
			@media screen and (max-width: $mq-tablet) {
			&:not(:last-child) {
				margin-bottom: 1.8em;
			}
			width: 100%
		}
		  }
	  }
  	input {
  		display: block;
  		border: 0;
  		font-size: 1.5em;
  		line-height: 1.2;
  		outline: none;
  		-webkit-appearance: none;
  		border-radius: 0;
  		background: transparent;
  		text-align: left;
  		&:invalid {
  			border: 0;
  			box-shadow: 0 0;
  		}
		@media screen and (max-width: $mq-tablet) {
			font-size: 3em;
		}
  	}
  	input[type='email'] {
  		width: 100%;
  	}
  	label {
  		display: block;
  		font-size: 1.5em;
  		line-height: 1.2;
  		outline: none;
		@media screen and (max-width: $mq-tablet) {
			font-size: 3em;
		}
  	}

  	p,
  	h1,
  	h2 {
  		// font-size: 3.5rem;
  		font-size: 1.5em;
  		line-height: 1.2;
		@media screen and (max-width: $mq-tablet) {
			font-size: 3em;
		}
  		// line-height: 1;
  	}
  	a {
  		font-size: 1em;
  		line-height: 1.2;
  	}
  	h1,
  	h2 {
  		// margin-bottom: 2.1rem;
  		margin-bottom: 0.6em;
  		// margin-bottom: 1.75rem;
  		&:not(:first-child) {
  			// margin-top: 4.2rem;
  			margin-top: 1.2em;
  			// margin-top: 3.5rem;
  		}
  	}
  	p,
  	address {
  		// margin-bottom: 2.1rem;
  		margin-bottom: 0.6em;
  		// margin-bottom: 1.75rem;
  		&:last-child {
  			margin-bottom: 0;
  		}
  	}
  	a {
  	}
  }
</style>
